import { render, staticRenderFns } from "./TeamRequestsManager.vue?vue&type=template&id=6e2321bc&scoped=true"
import script from "./teamRequestsManager.ts?vue&type=script&lang=ts&external"
export * from "./teamRequestsManager.ts?vue&type=script&lang=ts&external"
import style0 from "./TeamRequestsManager.vue?vue&type=style&index=0&id=6e2321bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2321bc",
  null
  
)

export default component.exports